import { useCallback } from 'react';
import { COLUMN_KEY } from '~/modules/resourcing/components/ResourceAssignmentDialog/enhancers';
import { AssignmentDialogColumns } from '~/modules/resourcing/components/ResourceAssignmentDialog/enhancers/constants';
import { filterColumnsByIsSmartMatchTabSelected } from '~/modules/resourcing/components/ResourceAssignmentDialog/enhancers/getColumns';

const useDialogSettingsSave = ({
  putTableSettings,
  setIsSaving,
  onClose,
  selectedOptions,
  tableKey,
  setEnabledAssignmentDialogColumns,
  setIsCostOptimizationSmartMatchModeEnabled,
  isPsaPraaResourceMatchingAllocationChartEnabled,
  isSmartMatchTabSelected
}) =>
  useCallback(async () => {
    setIsSaving(true);

    const tableColumnSettings = [];
    const selectedColumnFields = [];

    selectedOptions.forEach((selectedColumn, columnIndex) => {
      if (selectedColumn?.field === '') {
        return;
      }

      selectedColumnFields.push(selectedColumn.field);
      tableColumnSettings.push(
        `${COLUMN_KEY + columnIndex};${selectedColumn.field}`
      );
    });

    await putTableSettings({
      variables: {
        tableKey,
        columns: tableColumnSettings
      }
    });

    setIsCostOptimizationSmartMatchModeEnabled(
      isPsaPraaResourceMatchingAllocationChartEnabled
        ? isSmartMatchTabSelected &&
            selectedColumnFields.includes(
              AssignmentDialogColumns.SmartMatchIncludingCost
            )
        : selectedColumnFields.includes(
            AssignmentDialogColumns.SmartMatchIncludingCost
          )
    );

    setEnabledAssignmentDialogColumns(
      filterColumnsByIsSmartMatchTabSelected({
        columns: selectedColumnFields,
        isPsaPraaResourceMatchingAllocationChartEnabled,
        isSmartMatchTabSelected
      })
    );
    setIsSaving(false);
    onClose();
  }, [
    onClose,
    putTableSettings,
    selectedOptions,
    setIsSaving,
    tableKey,
    setEnabledAssignmentDialogColumns,
    setIsCostOptimizationSmartMatchModeEnabled,
    isPsaPraaResourceMatchingAllocationChartEnabled,
    isSmartMatchTabSelected
  ]);

export default useDialogSettingsSave;
